module.exports = __webpack_public_path__ + "img/manual-grn-04-status-changed.80eb8495.png";